import React from 'react'
import { theme } from '../../utils/theme'

const Button = ({onClick,className,children}) => {
  return (
    <div onClick={onClick} style={{backgroundColor:theme.color}} className={`${className} flex items-center justify-center cursor-pointer rounded-md text-white`}>
        {children}
    </div>
  )
}

export default Button